import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/speakap': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M64 391.8c-79.4-88.2-72-224.4 16.6-304.1 88.6-79.8 224.8-73 304.2 15.2 79.4 88.2 72 224.4-16.6 304.1-18.7 16.9 64 43.1 42 52.3-82.1 34.2-253.9 35-346.2-67.5h0zM277.3 180.2l38.5-40.9c-9.6-8.9-32-26.8-76.2-27.6-52.3-0.9-95.9 28.3-96.8 80-0.2 11.3 0.3 36.7 29.4 54.8 34.5 21.4 86.5 21.5 86 52.3-0.4 21.3-26.4 25.8-38.6 25.6-3 0-30.2-0.5-47.6-24.6l-40 42.6c28.2 27 59 32.6 83.5 33 10.2 0.2 96.4 0.3 97.8-81 0.3-15.8-2.1-39.7-28.9-56.6-34.4-21.6-85-19.5-84.4-49.8 0.4-23.3 31-25.4 37.5-25.3 0.4 0 26.6 0.3 39.6 17.4z'
      }
    ]
  }
})
